import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CustomButton from '../custom-material/button/Button'
import CustomDialog from '../custom-material/dialog/Dialog'

const styles = theme => ({
  dialogPaper: {
    width: 400,
    maxWidth: 400
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 16
  },
  confirmMessageContainer: {
    padding: 16
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingTop: 16
  },
  yesButton: {
    width: 100,
    marginLeft: 5,
    fontSize: 14,
    fontWeight: 600
  },
  cancelButton: {
    width: 100,
    fontSize: 14,
    fontWeight: 600
  }
})

const ConfirmDeleteDialog = ({classes, dialogOpen, handleCloseDialog, confirmDelete, nameOfItemToBeDeleted, typeToBeDeleted}) => (
  <CustomDialog classes={{paper: classes.dialogPaper}} open={dialogOpen} onClose={handleCloseDialog}>
    <div className={classes.contentContainer}>
      <div className={classes.confirmMessageContainer}>
        {`Are you sure you want to remove ${typeToBeDeleted === 'preference' && nameOfItemToBeDeleted ? 'your' : typeToBeDeleted === 'filter' && nameOfItemToBeDeleted ? 'the' : 'this'} ${nameOfItemToBeDeleted || ''} ${typeToBeDeleted}?`}
      </div>
      <div className={classes.actionContainer}>
        <CustomButton className={classes.cancelButton} onClick={handleCloseDialog} variant='contained' size='small' color='default' >Cancel</CustomButton>
        <CustomButton className={classes.yesButton} onClick={() => { confirmDelete(); return handleCloseDialog() }} variant='contained' size='small' color='secondary' >Yes</CustomButton>
      </div>
    </div>
  </CustomDialog>
)

ConfirmDeleteDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogOpen: PropTypes.bool.isRequired,
  handleCloseDialog: PropTypes.func.isRequired,
  confirmDelete: PropTypes.func.isRequired,
  nameOfItemToBeDeleted: PropTypes.string.isRequired,
  typeToBeDeleted: PropTypes.string.isRequired
}

export default withStyles(styles)(ConfirmDeleteDialog)
